import { passCodes } from '../passCodes';
import cipher26Image from '../../../../assets/images/games/zdar-escape-game/ciphers/26/image.webp';
import track26 from '../../../../assets/audio/tracks/track26.mp3';

const hints = [
    {
        text: 'Pořádně se podívejte do všech oken řeznictví.',
    },
    {
        text: 'Kódem je: topinambur',
        solution: true,
    },
];
export const step26butchers = {
    id: 24,
    title: '11. stanoviště',
    taskText: `
        <p>
            V této oblasti najdi mé oblíbené místo. A víš, co to je? No přeci řeznictví. Tam mi často dají nějakou mňamku s sebou. 
        </p>
    `,
    catImage: 2,
    audio: track26,
    snowAudio: track26,
    cipher: {
        images: [cipher26Image],
        label: 'Úkol',
        text: 'Když dojdete na místo, hledejte kód.',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[17],
    hints: hints,
    snowHints: hints,
};
